module.exports = __webpack_public_path__ + "static/ranger-04-13b8e7b5d31fc30b5d54bb607b01a1a1.png";